import SingleEventPage from "../../components/single-event-page/SingleEventPage";
import FreeFireImg from "../../assets/event-images/freefire.jpg";

const freeFire = {
  image: FreeFireImg,
  description:
    "Welcome to the thrilling near-future realm of FreeFire, where every moment pulses with heart-pounding action and strategic intensity! In this adrenaline-fueled tactical shooter, you and your team will embark on a journey like no other, navigating through dynamic landscapes and engaging in high-stakes battles.",
  type: "Elite Event",
  eventName: "Free Fire",
  dateTime: "Feb 24 / 25, 6PM-9PM",
  venue: "Online",
  rules: [
    "A team must contain a minimum of 4 members.",
    "Based on the number of teams, a BR ranked match will be conducted. The winners of those ranked matches will compete in a 1 vs 1 clash squad. The winner and runner-up will be decided by the clash squad match.",
    "Treat others how you wish to be treated—be kind and courteous. Respect everyone regardless of gender, ethics, and age.",
    "No inappropriate usernames or nicknames are allowed.",
    "No teaming up is allowed. Using emotes in the final clash squad match is not fair.",
    "Verbal abuse in all chat will not be tolerated. Proof of such behavior may result in a ban from the tournament.",
    "It is forbidden to cheat, modify game files, exploit bugs, or use any third-party applications that give an unfair advantage.",
    "Cheating, including exploiting bugs and using hacks, will not be tolerated and will disqualify the entire team from the event.",
    "Team captains will be informed of any changes in match schedules.",
    "If any team member violates any rule, the entire team will be banned from the tournament."
],

  firstprize: 2000,
  secondprize: 1000,
  thirdprize: 0,
  contact: [
    {
      name: "Aadhithya KNV",
      phoneNo: "7708104181",
    },
    {
      name: "Haritha",
      phoneNo: "8754025608",
    },
  ],
};

const FreeFire = () => {
  return (
    <SingleEventPage
      eventDetails={freeFire}
      formsLink={"https://docs.google.com/forms/d/e/1FAIpQLScqmF3z5EoH1voQLNCbMEu_pWc3YVLQIg6ULQ3FgpO35FSMPQ/viewform?usp=dialog"}
      noVenue={true}
    />
  );
};

export default FreeFire;
